<template>
  <v-container fluid class ="py-0">
    <v-row :class="row_color">
      <v-card flat color="transparent" class="mx-auto py-6 text-center" >
        <v-card-title class="display-1 mb-2">{{ $t("about.about") }}</v-card-title>
        <v-card-subtitle class="subtitle-1">ABOUT US</v-card-subtitle>
      </v-card>
    </v-row>
    <v-row>
      <v-card flat color="transparent" :class="row_padding" >
        <v-card-title class="display-1 mb-2">{{ title }}</v-card-title>
      </v-card>
    </v-row>
    <slot></slot>
  </v-container>
</template>

<script>
export default {
    name: 'TciAboutUs',
    props: {
      title: String,
      row_color: {
        default: 'grey lighten-2',
        type: String
      },
      row_padding: {
        default: 'mx-auto py-6 text-center',
        type: String
      }
    }
}
</script>
